import React from 'react';
import { t } from '@sm/intl';

import { useParams } from 'react-router';
import { Link } from 'react-router-dom';
import { Box } from '@wds/box';

import { NavRouteParams } from '~pricing/components/Navigation/types';
import { PackageProps, PackageType } from '~shared/types/pricing/package';

import PackageCta from '../../components/PackageCta';
import PackageHeader from '../../components/PackageHeader';
import usePackageStyles from './useStyles';
import FeatureSet from '~pricing/components/FeatureSet';
import useTrackingDetails from '~pricing/hooks/useTrackingDetails';
import useSummaryDisplayFeatures from '~pricing/hooks/useSummaryDisplayFeatures';
import PackageDefs from '~pricing/lib/packages/packageDefs';

import COPY from '~pricing/copy';

export default function Package({
  skuCost,
  packageName,
  features,
  comparePlans,
  isLastPackage,
  discountInfo,
}: Readonly<PackageProps>): React.ReactElement | null {
  const { canonicalPath = PackageType.Teams } = useParams<NavRouteParams>();
  const displayFeatures = useSummaryDisplayFeatures(features, packageName);

  const { PricingPackageContainer, PricingPackage, Highlighted, PlanFeaturesLink } = usePackageStyles({
    packageName,
  });
  const { pageUtSource } = useTrackingDetails();

  if (!displayFeatures) {
    return null;
  }

  return (
    <Box
      element="article"
      className={`${PricingPackageContainer} package-${packageName}`}
      key={packageName}
      data-testid="Package__TreatmentOne"
    >
      <Box className={`${PricingPackage} ${PackageDefs[packageName]?.highlighted ? Highlighted : ''}`}>
        <PackageHeader packageName={packageName} skuCosts={skuCost} isSummaryPage discountInfo={discountInfo} />
        <FeatureSet features={displayFeatures} packageName={packageName} isLastPackage={isLastPackage} />
        {!comparePlans && (
          <Box className={PlanFeaturesLink}>
            <Link to={`/pricing/${canonicalPath}/details?ut_source=${pageUtSource}`}>{t(COPY.PLAN_FEATURES)}</Link>
          </Box>
        )}
      </Box>
      <PackageCta packageName={packageName} isSummaryPage />
    </Box>
  );
}
